import "../../nuove-sezioni/Icone";
import styles from "./ChiSono.module.scss";
import { chiSono as c } from "../../../types/content";
import { Media, cx } from "../Icone";
import { Immagine } from "../types";
// import type { Immagine } from "../../../types/content";

interface ChiSonoProps {
  /** La foto si può passare direttamente: <ChiSono foto={miaFoto} />. Se non la passi usa quella in content.ts */
  foto?: Immagine;
}

const ChiSono = ({ foto = c.foto }: ChiSonoProps) => {
  return (
    <div className={styles["chi-sono"]} id="chi-sono">
      {/* Apertura */}
      <section className={styles["chi-sono__intro"]}>
        <div className={styles["chi-sono__testo"]}>
          <span className={styles["chi-sono__eyebrow"]}>{c.etichetta}</span>
          <h2 className={styles["chi-sono__titolo"]}>
            {c.saluto}{" "}
            <em className={cx(styles["chi-sono__serif"], styles["chi-sono__accent"])}>{c.nome}</em>
          </h2>
          <p className={styles["chi-sono__frase"]}>{c.frase}</p>
          <p className={styles["chi-sono__paragrafo"]}>{c.testo}</p>
        </div>
        <div className={styles["chi-sono__foto"]}>
          <Media
            src={foto}
            alt="Agnese Morlin"
            segnaposto="il tuo ritratto"
            className={styles["chi-sono__ritratto"]}
          />
          {c.adesivi[0] && (
            <span className={cx(styles["chi-sono__adesivo"], styles["chi-sono__adesivo--uno"])}>
              {c.adesivi[0]}
            </span>
          )}
          {c.adesivi[1] && (
            <span className={cx(styles["chi-sono__adesivo"], styles["chi-sono__adesivo--due"])}>
              {c.adesivi[1]}
            </span>
          )}
        </div>
      </section>

      {/* La mia storia */}
      <section className={styles["chi-sono__storia"]}>
        <div className={styles["chi-sono__storia-inner"]}>
          <div className={styles["chi-sono__head"]}>
            <h2 className={styles["chi-sono__h2"]}>
              {c.storiaTitolo}{" "}
              <em className={cx(styles["chi-sono__serif"], styles["chi-sono__pop"])}>
                {c.storiaTitoloCorsivo}
              </em>
            </h2>
            <p className={styles["chi-sono__storia-intro"]}>{c.storiaIntro}</p>
          </div>
          <div className={styles["chi-sono__capitoli"]}>
            {c.capitoli.map((cap, i) => (
              <article
                key={cap.titolo}
                className={cx(
                  styles["chi-sono__capitolo"],
                  cap.evidenza && styles["chi-sono__capitolo--evidenza"]
                )}
              >
                <span className={styles["chi-sono__capitolo-num"]}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className={styles["chi-sono__h3"]}>{cap.titolo}</h3>
                <p className={styles["chi-sono__capitolo-testo"]}>{cap.testo}</p>
                <span className={styles["chi-sono__capitolo-quando"]}>{cap.quando}</span>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Citazione */}
      <section className={styles["chi-sono__citazione"]}>
        <blockquote>
          <p>“{c.citazione}”</p>
          <footer>— {c.firma}</footer>
        </blockquote>
      </section>

      {/* Come lavoro */}
      <section className={styles["chi-sono__come"]}>
        <h2 className={styles["chi-sono__h2"]}>
          Come <em className={styles["chi-sono__serif"]}>lavoro</em>
        </h2>
        <div className={styles["chi-sono__principi"]}>
          {c.comeLavoro.map((p) => (
            <div key={p.titolo} className={styles["chi-sono__principio"]}>
              <h3 className={styles["chi-sono__principio-titolo"]}>{p.titolo}</h3>
              <p className={styles["chi-sono__principio-testo"]}>{p.testo}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ChiSono;
